import { IconList, IconHome, IconZoomQuestion } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const Benefits = () => {
    const { t } = useTranslation();

    const cards = [
        {
            title: t('welcome_dialog:cards:multi_site:title'),
            body: t('welcome_dialog:cards:multi_site:body'),
            icon: IconList,
        },
        {
            title: t('welcome_dialog:cards:streamlined:title'),
            body: t('welcome_dialog:cards:streamlined:body'),
            icon: IconHome,
        },
        {
            title: t('welcome_dialog:cards:get_help:title'),
            body: t('welcome_dialog:cards:get_help:body'),
            icon: IconZoomQuestion,
        },
    ];

    return (
        <div className="flex flex-col xl:flex-row items-center gap-6 mb-6">
            {cards.map(({ title, body, icon: Icon }) => (
                <div
                    key={title}
                    className="flex flex-col items-center justify-start p-4 gap-2.5 rounded-lg shadow-lg bg-gray-50 flex-1 self-stretch"
                    role="article"
                >
                    <Icon className="text-primary-700 w-[40px] h-[40px] xxl:w-[50px] xxl:h-[50px]" />
                    <h4 className="font-semibold text-center">{title}</h4>
                    <p className="text-center">{body}</p>
                </div>
            ))}
        </div>
    );
};
